const STORAGE_KEY = 'fuu:visited';
const CONTENT_DELAY = 500;
const HIDE_DELAY = 2500;

/** sessionStorage が使えない環境（プライベートモード等）でも落とさない */
const hasVisited = () => {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY) !== null;
  } catch {
    return false;
  }
};

const markVisited = () => {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, '1');
  } catch {
    /* noop */
  }
};

/**
 * 初回アクセス時だけローディング画面を表示する。
 * フェードは CSS のトランジションに任せ、JS は状態クラスの付け外しのみ行う。
 */
export const initLoader = () => {
  const loader = document.querySelector('.js-load');
  if (!loader) return;

  if (hasVisited()) {
    loader.remove();
    return;
  }

  markVisited();

  const contents = loader.querySelector('.js-load__contents');
  window.setTimeout(() => contents?.classList.add('is-visible'), CONTENT_DELAY);
  window.setTimeout(() => {
    loader.classList.add('is-hidden');
    loader.addEventListener('transitionend', () => loader.remove(), { once: true });
  }, HIDE_DELAY);
};
